
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";


import { ConsignorService } from '../ApplicationServices/ConsignorService';
import { ConsigneeService } from '../ApplicationServices/ConsigneeService';

import { ConsignorElement } from '../models/ConsignorModel';
import { ConsigneeElement } from '../models/ConsigneeModel';

import { SharedService } from '../ApplicationServices/SharedService';

import { ActivatedRoute, Router } from "@angular/router";
import { ItemModifierService } from "../ApplicationServices/ItemModifierServices";
import { LoginService } from "../ApplicationServices/LoginService";
import { UserInfoStore } from "../shared/store/userInfo.store";
import { CustomValidators } from '../custom-validators';


@Component({
  selector: 'app-updateprofile',
  templateUrl: './updateprofile.component.html',
  styleUrls: ['./updateprofile.component.scss']
})
export class UpdateprofileComponent implements OnInit {


    billingaddress = [];   shippingaddress = [];
    closeResult: string;
    alertmsg: string = null;  showAlert: boolean = false;
    showAlert1: boolean = false; showAlert2: boolean = false;


     operationstate: number = 0;
     IDS: number = 0;

      newproductData: any;
      countryData:any;
      stateData:any;
      cityData:any;

      ConsigneeForm: FormGroup;
      ConsignorForm: FormGroup;
      AddressSelectionForm: FormGroup;
      AddressSelectionFormConsignee: FormGroup; AddressSelectionFormConsignor: FormGroup;
      submitted = false;
      consignorsubmitted = false;

      adresses = [
        {
          id: 1,
          email: "abc@gmail.com",
          phone: "9804526251",
          postcode: "700055",
          state: "West Bengal",
          address: "73 Sarat Bose Road , PO Naktala Kolkata",
          lastname: "Ray",
          firstname: "Abhik",
          isDefault: true,
        },
        {
          id: 2,
          email: "abasdasdc@gmail.com",
          phone: "9124526251",
          postcode: "700235",
          state: "Bihar",
          address: "73 Sarat Bose Road , PO Naktala Kolkata",
          lastname: "Mukherjee",
          firstname: "Parmit",
          isDefault: false,
        },
      ];

      constructor(

        private formBuilder: FormBuilder,private modalService: NgbModal,
        private cnorService: ConsignorService, private cneeService: ConsigneeService,
        private shareService: SharedService,
        private loginService: LoginService,
        private route: ActivatedRoute,
        private router: Router,
        private infoStore: UserInfoStore,
        private itemModifierService: ItemModifierService


        ) {


        this.AddressSelectionForm = this.formBuilder.group({
          adresses: [""],
        });

        this.AddressSelectionFormConsignor = this.formBuilder.group({
          billingaddress: [""],
        });

        this.AddressSelectionFormConsignee = this.formBuilder.group({
          shippingaddress: [""],
        });


        this.ConsignorForm = this.formBuilder.group({

          UserId:[0, Validators.required],
          UserFullName: ["", Validators.required],
          UserPassword: ["", Validators.required],
          confirmedPassword: ["", Validators.required],
          UserMail: ["", Validators.required],
          UserContactNO: ["", Validators.required],


        });


      }
      active = 1;


      ngOnInit() {

        this.FillBillingAddressData();
        //this.FillShippingAddressData();

        this.getNewProductList();
        this.shareService.getAllFillStateByCountryIdData(101)
        .subscribe(
        (datast) => {
        this.stateData = datast;}
        );

        this.shareService.getAllFillCityByStateIdData(0)
        .subscribe(
          (datact) => {
        this.cityData = datact; }
        );

      }


      getNewProductList() {
        this.newproductData = [
          { ViewStateNewProduct: "NO" },
          { ViewStateNewProduct: "YES" },
        ];
      }

      onOptionsSelectedState(value){
        console.log(value);
          this.shareService.getAllFillCityByStateIdData(value)
          .subscribe(
            (datact) => {

              this.cityData = datact;

            }

          );
        }






      get selectedAdress() {
        return this.AddressSelectionFormConsignor.get("billingaddress").value;
        //return this.AddressSelectionFormConsignee.get("shippingaddress").value;
      }

      get selectedAdressShipping() {
        return this.AddressSelectionFormConsignee.get("shippingaddress").value;
      }






      onConsigneeAdd() {


        // this.consignorsubmitted = true;
      //  console.log(this.ConsignorForm.value);

        //call the service here

       if(

        this.ConsigneeForm.value.State_Id=='' || this.ConsigneeForm.value.City_Id=='' ||
        this.ConsigneeForm.value.FullName==''||
        this.ConsigneeForm.value.MobileNumber==''|| this.ConsigneeForm.value.PinCode==''||
        this.ConsigneeForm.value.FlatHouseNoBuildingCompanyApartment==''|| this.ConsigneeForm.value.AreaColonyStreetSectorVillage==''||
        this.ConsigneeForm.value.LandMark=='' ||
        this.ConsigneeForm.value.State_Id==null || this.ConsigneeForm.value.City_Id==null ||
        this.ConsigneeForm.value.FullName==null||
        this.ConsigneeForm.value.MobileNumber==null|| this.ConsigneeForm.value.PinCode==null||
        this.ConsigneeForm.value.FlatHouseNoBuildingCompanyApartment==null|| this.ConsigneeForm.value.AreaColonyStreetSectorVillage==null||
        this.ConsigneeForm.value.LandMark==null

        )
        {

         this.alertmsg = "Required Fields Must Be Filled !!";
         this.showAlert1 = true;
         setTimeout(() => {
           this.showAlert1 = false;
         }, 2000);

        }else{


         // const formData = new FormData();
         // var obj = {
         //   UserRoleId: 8, //Operator
         //   CompId: 1,
         //   BranchId: 1,
         //   UserFullName: this.registerForm.value.userFullName,
         //   UserName: this.registerForm.value.email,
         //   UserPassword: this.registerForm.value.password,
         //   UserMail: this.registerForm.value.email,
         //   UserContactNO: this.registerForm.value.phone,
         //   OperationType: "INSERT",
         // };
         // formData.append("params", JSON.stringify(obj));
         // this.loginService.register(obj).subscribe((event: any) => {
         //   if (event && event.length > 0) {
         //     console.log(event);
         //     if (event[0].OperationStatus == "Successfully Saved") {
         //       this.alertmsg = "User Registered Successfully !";
         //     }
         //     else
         //     {
         //       this.alertmsg = event[0].OperationStatus;
         //     }
         //     this.showAlert2 = true;
         //     setTimeout(() => {
         //       this.showAlert2 = false;
         //     }, 3000);
         //   }
         // });

         var objj = new ConsigneeElement();

         // objj.ConsignorId = 0;

         if( this.operationstate==0){

           objj.ConsigneeId = 0;
           objj.OperationType= "insert";

         }else{

           objj.ConsigneeId = this.IDS;
           objj.OperationType= "update";

         }

         objj.Country_Id =101;
         objj.MobileNumber=this.ConsigneeForm.value.MobileNumber;
         objj.State_Id =this.ConsigneeForm.value.State_Id;
         objj.City_Id =this.ConsigneeForm.value.City_Id;
         objj.FullName =this.ConsigneeForm.value.FullName;
         objj.PinCode =this.ConsigneeForm.value.PinCode;
         objj.FlatHouseNoBuildingCompanyApartment =this.ConsigneeForm.value.FlatHouseNoBuildingCompanyApartment;
         objj.AreaColonyStreetSectorVillage =this.ConsigneeForm.value.AreaColonyStreetSectorVillage;
         objj.LandMark =this.ConsigneeForm.value.LandMark;

         if( this.ConsigneeForm.value.SetDefault=='' || this.ConsigneeForm.value.SetDefault==null ){
           objj.SetDefault =0;
         }
         else  if( this.ConsigneeForm.value.SetDefault=='YES')
         {
           objj.SetDefault =1;
         }
         else{
           objj.SetDefault =0;
         }

         objj.CreatedBy = Number(sessionStorage.getItem("UID"));

         this.cneeService.insertConsigneeData(objj).subscribe((event: any) => {
             if (event && event.length > 0) {
               console.log(event);
               if (event[0].OperationStatus == "Successfully Saved") {

                 this.alertmsg = "Billing Address Saved Successfully !";

                 this.ConsigneeForm.reset();
                 this.FillShippingAddressData();
                 this.operationstate=0;

               }
               else
               {

                 //this.alertmsg = event[0].OperationStatus;
                 this.ConsigneeForm.reset();
                 this.FillShippingAddressData();
                 this.operationstate=0;

               }
               this.showAlert1 = true;
               setTimeout(() => {
                 this.showAlert1 = false;
               }, 3000);
             }
           });


        }

      }

      onConsignorAdd(datas) {

          // this.consignorsubmitted = true;
         //  console.log(this.ConsignorForm.value);
        //call the service here


       if(

        //  this.ConsignorForm.value.UserFullName=='' || 
        //  ///  this.ConsignorForm.value.UserContactNO==''  ||
        //  this.ConsignorForm.value.UserMail=='' || this.ConsignorForm.value.UserPassword=='' ||
        //  this.ConsignorForm.value.confirmedPassword=='' ||
        //  this.ConsignorForm.value.UserFullName==null ||
        //  //|| this.ConsignorForm.value.UserContactNO==null  ||
        //  this.ConsignorForm.value.UserMail==null || this.ConsignorForm.value.UserPassword==null ||
        //  this.ConsignorForm.value.confirmedPassword==null


        datas.UserFullName=='' || 
         ///  this.ConsignorForm.value.UserContactNO==''  ||
         datas.UserMail=='' || datas.UserPassword=='' ||
         datas.confirmedPassword=='' ||
         
         datas.UserFullName==null ||
         //|| this.ConsignorForm.value.UserContactNO==null  ||
         datas.UserMail==null || datas.UserPassword==null ||
         datas.confirmedPassword==null

         )

       {

        this.alertmsg = "Required Fields Must Be Filled !!";
        this.showAlert = true;
        setTimeout(() => {
          this.showAlert = false;
        }, 2000);

       }
       else if( this.ConsignorForm.value.UserPassword != this.ConsignorForm.value.confirmedPassword )
       {

         this.alertmsg = "Access denied , Password & Confirm Password is mismatched !";
         this.showAlert2 = true;
         setTimeout(() => {
           this.showAlert2 = false;
         }, 3000);
         //return;

       }

       else{


        const formData = new FormData();
        var obj = {
          UserId:this.IDS,
          UserRoleId: 6, //Operator
          CompId: 2,
          BranchId: 4,
          UserFullName: this.ConsignorForm.value.UserFullName,
          UserName: this.ConsignorForm.value.UserMail,
          UserPassword: this.ConsignorForm.value.UserPassword,
          UserMail: this.ConsignorForm.value.UserMail.trim(),
          UserContactNO: this.ConsignorForm.value.UserContactNO,
          OperationType: "update",
          Notes:"WEBSITE"
        };
        formData.append("params", JSON.stringify(obj));
        this.loginService.register(obj).subscribe((event: any) => {
          if (event && event.length > 0) {
            console.log(event);
            if (event[0].OperationStatus == "Successfully Updated") {

              this.alertmsg = "User Registered Successfully !";
              this.ConsignorForm.reset();
              this.FillBillingAddressData();

            }
            else
            {
              this.alertmsg = event[0].OperationStatus;
            }
            this.showAlert2 = true;
            setTimeout(() => {
              this.showAlert2 = false;
            }, 3000);
          }
        });

        // var objj = new ConsignorElement();



        // if( this.operationstate==0){

        //   objj.ConsignorId = 0;
        //   objj.OperationType= "insert";

        // }else{

        //   objj.ConsignorId = this.IDS;
        //   objj.OperationType= "update";

        // }

        // objj.Country_Id =101;
        // objj.MobileNumber=this.ConsignorForm.value.MobileNumber;
        // objj.State_Id =this.ConsignorForm.value.State_Id;
        // objj.City_Id =this.ConsignorForm.value.City_Id;
        // objj.FullName =this.ConsignorForm.value.FullName;
        // objj.PinCode =this.ConsignorForm.value.PinCode;
        // objj.FlatHouseNoBuildingCompanyApartment =this.ConsignorForm.value.FlatHouseNoBuildingCompanyApartment;
        // objj.AreaColonyStreetSectorVillage =this.ConsignorForm.value.AreaColonyStreetSectorVillage;
        // objj.LandMark =this.ConsignorForm.value.LandMark;

        // if( this.ConsignorForm.value.SetDefault=='' || this.ConsignorForm.value.SetDefault==null ){
        //   objj.SetDefault =0;
        // }
        // else  if( this.ConsignorForm.value.SetDefault=='YES')
        // {
        //   objj.SetDefault =1;
        // }
        // else{
        //   objj.SetDefault =0;
        // }

        // objj.CreatedBy = Number(sessionStorage.getItem("UID"));


        // this.cnorService.insertConsignorData(objj).subscribe((event: any) => {
        //     if (event && event.length > 0) {
        //       console.log(event);
        //       if (event[0].OperationStatus == "Successfully Saved") {

        //         this.alertmsg = "Billing Address Saved Successfully !";

        //         this.ConsignorForm.reset();
        //         this.FillBillingAddressData();
        //         this.operationstate=0;

        //       }
        //       else
        //       {
        //         //this.alertmsg = event[0].OperationStatus;
        //         this.ConsignorForm.reset();
        //         this.FillBillingAddressData();
        //         this.operationstate=0;

        //       }
        //       this.showAlert1 = true;
        //       setTimeout(() => {
        //         this.showAlert1 = false;
        //       }, 3000);
        //     }
        //   });


       }


    }




      FillBillingAddressData(){
        this.loginService
           .getAllAppUserByIdData(parseInt(sessionStorage.getItem("UID")))
           /// .getAllAppUserByIdData(0)
          .subscribe((event: any) => {
            if (event.length > 0) {
              this.billingaddress = event;

                // if (event[0].OperationStatus == "Successfully Saved") {
               //   alert("done");
              // }

            } else {
              this.billingaddress = [];

            }
          });


      }


      FillShippingAddressData(){
        this.cneeService
          .getAllConsigneeMasterByUserIdData(parseInt(sessionStorage.getItem("UID")))
          .subscribe((event: any) => {
            if (event.length > 0) {
              this.shippingaddress = event;

                // if (event[0].OperationStatus == "Successfully Saved") {
               //   alert("done");
              // }

            } else {
              this.shippingaddress = [];
            }
          });


      }




      get f() {
        return this.ConsigneeForm.controls;
      }

      // convenience getter for easy access to form fields
      get r() {
        return this.ConsignorForm.controls;
      }


      editAddressBilling(id){

        this.IDS=id;
        //this.operationstate=1;
        var comp = null;
        this.loginService
          .getAllAppUserByIdData(id)
          .subscribe((event: any) => {
            if (event.length > 0) {
              comp = event;
                // if (event[0].OperationStatus == "Successfully Saved") {
               //   alert("done");
              // }
              this.ConsignorForm.setValue({

                UserId : id,
                //Country_Id :101,
                UserFullName:event[0].UserFullName,
                UserContactNO :event[0].UserContactNO,
                UserMail :event[0].UserMail,
                UserPassword :event[0].UserPassword,
                confirmedPassword :event[0].UserPassword,


              });

            }
          });



        // this.ConsignorForm.setValue({

        //   ConsignorId : id,
        //   //Country_Id :101,
        //   MobileNumber:comp.MobileNumber,
        //   State_Id :comp.State_Id,
        //   City_Id :comp.City_Id,
        //   FullName :comp.FullName,
        //   PinCode :comp.PinCode,
        //   FlatHouseNoBuildingCompanyApartment :comp.FlatHouseNoBuildingCompanyApartment,
        //   AreaColonyStreetSectorVillage :comp.AreaColonyStreetSectorVillage,
        //   LandMark :comp.LandMark,
        //   SetDefault : comp.SetDefault=0? 'NO':'YES' ,


        // });


      }


      deleteAddressBilling(id){

        var objj = new ConsignorElement();

          objj.ConsignorId =id;
          objj.OperationType= "delete";
          objj.CreatedBy = Number(sessionStorage.getItem("UID"));


        this.cnorService.insertConsignorData(objj).subscribe((event: any) => {
          if (event && event.length > 0) {
             //console.log(event);
           // if (event[0].OperationStatus == "Successfully Deleted") {

              this.alertmsg = "Deleted !";

              this.ConsignorForm.reset();
              this.FillBillingAddressData();
              this.operationstate=0;

           // }
           // else
            //{
              //this.alertmsg = event[0].OperationStatus;
              this.ConsignorForm.reset();
              this.FillBillingAddressData();
              this.operationstate=0;

            //}
            this.showAlert1 = true;
            setTimeout(() => {
              this.showAlert1 = false;
            }, 3000);
          }
        });

      }





      editAddressShipping(id){

        this.IDS=id;
        this.operationstate=1;
        var comp = null;
        this.cneeService
          .getAllConsigneeMasterByConsigneeIdData(id)
          .subscribe((event: any) => {
            if (event.length > 0) {
              comp = event;
                // if (event[0].OperationStatus == "Successfully Saved") {
               //   alert("done");
              // }
              this.ConsigneeForm.setValue({

                ConsigneeId : id,
                //Country_Id :101,
                MobileNumber:event[0].MobileNumber,
                State_Id :event[0].State_Id,
                City_Id :event[0].City_Id,
                FullName :event[0].FullName,
                PinCode :event[0].PinCode,
                FlatHouseNoBuildingCompanyApartment :event[0].FlatHouseNoBuildingCompanyApartment,
                AreaColonyStreetSectorVillage :event[0].AreaColonyStreetSectorVillage,
                LandMark :event[0].LandMark,
                SetDefault : event[0].SetDefault=0? 'NO':'YES' ,


              });

            }
          });



        // this.ConsignorForm.setValue({

        //   ConsignorId : id,
        //   //Country_Id :101,
        //   MobileNumber:comp.MobileNumber,
        //   State_Id :comp.State_Id,
        //   City_Id :comp.City_Id,
        //   FullName :comp.FullName,
        //   PinCode :comp.PinCode,
        //   FlatHouseNoBuildingCompanyApartment :comp.FlatHouseNoBuildingCompanyApartment,
        //   AreaColonyStreetSectorVillage :comp.AreaColonyStreetSectorVillage,
        //   LandMark :comp.LandMark,
        //   SetDefault : comp.SetDefault=0? 'NO':'YES' ,


        // });


      }


      deleteAddressShipping(id){

        var objj = new ConsigneeElement();

          objj.ConsigneeId =id;
          objj.OperationType= "delete";
          objj.CreatedBy = Number(sessionStorage.getItem("UID"));


        this.cneeService.insertConsigneeData(objj).subscribe((event: any) => {
          if (event && event.length > 0) {
             //console.log(event);
           // if (event[0].OperationStatus == "Successfully Deleted") {

              this.alertmsg = "Deleted !";

              this.ConsigneeForm.reset();
              this.FillShippingAddressData();
              this.operationstate=0;

           // }
           // else
            //{
              //this.alertmsg = event[0].OperationStatus;
              this.ConsigneeForm.reset();
              this.FillShippingAddressData();
              this.operationstate=0;

            //}
            this.showAlert1 = true;
            setTimeout(() => {
              this.showAlert1 = false;
            }, 3000);
          }
        });

      }




  }
